import { z } from "zod";
import { createInvoiceRequestSchema } from "../createInvoice/createInvoice.schema";

export const updateInvoiceRequestSchema = createInvoiceRequestSchema
  .partial()
  .extend({
    invoiceID: z.string().min(1, "Invoice ID is required"),
  });

export type TUpdateInvoiceRequest = z.infer<typeof updateInvoiceRequestSchema>;
